

import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import signup from '@/components/signup'
import core from '@/components/core'
import home from '@/components/home';
import healthCheck from '@/components/healthCheck';

import fileLoader from '@/components/fileLoader'
import Seguimientolist from '@/components/Seguimientolist';
import EstatusPagos from '@/components/EstatusPagos';


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: core,
      children: [
        {
          path: '/',
          component: home,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/Seguimientolist/',
          name: 'Seguimientolist',
          component: Seguimientolist,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/fileLoader',
          name: 'fileLoader',
          component: fileLoader,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/EstatusPagos/',
          name: 'EstatusPagos',
          component: EstatusPagos,
          meta: {
            requiresAuth: false
          }
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/passwordrecovery/:token',
      name: 'passwordrecovery',
      component: login,
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/health',
      name: 'health',
      component: healthCheck,
    } 
  ]
})

